/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.inscriptionStyle.ts
 *
 * Messages du chantier du 2026-10-04 (Mika, « c'est moche ») : les écrans
 * /role et /inscription/:role reprennent l'habillage de l'inscription
 * animateur (carte blanche, titre centré, indicateur d'étapes numérotées).
 * Ce sous-catalogue porte les libellés de cet indicateur et du compteur de
 * champs remplis. Vocabulaire de l'événement par jetons, jamais en dur.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesInscriptionStyleFr: Record<string, string> = {
  // Nom accessible de la liste ordonnée des étapes.
  'inscriptionStyle.etapes.label': 'Étapes de l’inscription',
  'inscriptionStyle.etape.informations': 'Vos informations',
  'inscriptionStyle.etape.cv': 'Votre CV',
  'inscriptionStyle.etape.badge': 'Votre badge',
  // Profils dont le compte attend une validation : pas de badge immédiat.
  'inscriptionStyle.etape.espace': 'Votre espace',
  // Remplace « Étape {step} sur {total} » au-dessus du formulaire : à côté
  // de l'indicateur d'étapes, ce libellé aurait désigné deux choses.
  'inscriptionStyle.remplissage':
    '{step, plural, =0 {Aucun champ rempli} one {# champ rempli} other {# champs remplis}} sur {total}',
  // Appels visibles des cartes /role : le libellé générique « Je suis
  // {role} » retombait sur « participant » pour ces deux profils. Le nom
  // accessible des boutons (« Je suis … ») ne change pas.
  'inscriptionStyle.cta.animateur': 'J’ai un code d’accès',
  'inscriptionStyle.cta.accompagnateur': 'Je m’inscris',
};
